import React, { useCallback, useRef, useState } from 'react';
import { ocrImageToTotal } from '../utils/ocrImageToTotal';
import { Tooltip } from './Tooltip'; // ★ 既存の共通Tooltipを利用

export default function OcrFillButton({
  onApply,
  onLowConfidence,
  onError,
  onStart,
  threshold = 70,
  className,
  // ★ 追加：既存InputFieldと同じ考え方のprops
  tooltipText = '数字一覧のみ取り込み可能',
  tooltipImageSrc = 'img/ocr_sample.png', // 既存が先頭スラなしなので合わせる
}) {
  const inputRef = useRef(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleClick = useCallback(() => {
    inputRef.current?.click();
  }, []);

  const handleChange = useCallback(
    async (event) => {
      const file = event.target.files?.[0];
      if (!file) return;

      onStart?.();
      setIsProcessing(true);
      try {
        const result = await ocrImageToTotal(file);
        onApply?.(result.total, result);

        if (onLowConfidence) {
          if (result.confidence != null && result.confidence < threshold) {
            onLowConfidence(result);
          } else {
            onLowConfidence(null);
          }
        }
      } catch (err) {
        console.error('[OcrFillButton] OCR failed', err);
        onError?.(err);
      } finally {
        setIsProcessing(false);
        if (event.target) event.target.value = ''; // 同じファイル再選択に備えリセット
      }
    },
    [onApply, onError, onLowConfidence, onStart, threshold]
  );

  const wrapperClass = ['flex items-center gap-2', className].filter(Boolean).join(' ');

  // ★ Tooltipに渡すコンテンツ（既存Tooltipのcontentは任意のJSX可）
  const tooltipContent = (
    <div className="flex flex-col items-center">
      <img
        src={tooltipImageSrc}
        alt="OCRサンプル"
        className="max-w-[200px] max-h-[200px] object-contain"
      />
      <div className="text-xs">{tooltipText}</div>
    </div>
  );

  return (
    <div className={wrapperClass}>
      {/* ★ 既存Tooltipで包むだけ */}
      <Tooltip content={tooltipContent}>
        <span role="img" aria-label="画像取り込みの説明" tabIndex={0}></span>
        <span className="ml-1 text-blue-500 cursor-pointer">ⓘ</span>
      </Tooltip>
      <button
        type="button"
        className="bg-blue-100 hover:bg-blue-200 text-blue-800 font-semibold py-1.5 px-4 rounded"
        onClick={handleClick}
        disabled={isProcessing}
      >
        {isProcessing ? '解析中…' : '画像から反映'}
      </button>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        data-testid="ocr-image-input"
        onChange={handleChange}
      />
    </div>
  );
}
